<template>
  <div
    :class="[
      'post-form',
      { 'post-form--expand': isFormVisible },
      { 'post-form--editing': !isNew },
    ]"
    @click="openForm"
    @keydown="keyPressed"
  >
    <!-- TODO click outside  -->
    <el-avatar class="post-form__avatar" :size="36">
      <user-avatar :userId="currentUser.userId" :alt="currentUser.firstName + ' ' + currentUser.lastName" />
    </el-avatar>

    <div class="post-form__label">
      Add a post
    </div >

    <div v-if="isFormVisible">
      <el-input            
        v-model="title"
        class="post-form__title"
        ref="titleInput"
        type="text"
        placeholder="Enter post title (optional)"
        maxlength="200"
      ></el-input>

      <quill-editor
        v-if="(contentType === 'html' || contentType === 'delta' || contentType === 'markdown')"
        v-model:content="content"
        class="post-form__input__quill"
        ref="quillInput"
        :options="editorOptions"
        :contentType="contentType"
        toolbar="full"
        theme="snow"
      >
      </quill-editor>

      <el-input
        v-if="( contentType === undefined || contentType === 'text')"
        v-model="text"
        class="post-form__input__text"
        ref="input"
        :rows="4"
        name="post-form-text"
        @input="autoSizeTextarea"
        maxlength="4000"
        :autosize="{ minRows: 2, maxRows: 4 }"
        type="textarea"
        placeholder="Write post"/>
    </div>

    <div class="post-form__bottom">
      <!--div class="post-form__extra">
        <el-button icon="el-icon-camera" type="primary"></el-button>
        <el-button icon="el-icon-video-camera" type="primary"></el-button>
        <el-button icon="el-icon-location-outline" type="primary"></el-button>
      </div-->

      <div class="post-form__buttons">
        <el-button type="primary" @click="onReset">
          {{ isNew ? 'Reset' : 'Cancel' }}
        </el-button>
        <el-button
          type="primary"
          @click="validate"
          :disabled="isButtonDisabled('save-post')"
        >
          {{ isNew ? 'Post' : 'Save' }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { addBlogPost } from '@/api/blog.js';
import { updateBlogPost } from '@/api/blog.js';
import { showMessage } from '@/utils/messages.js';
import { disableButton } from '@/mixins/disableButton.js';

import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import UserAvatar from '@/components/profile/UserAvatar.vue';

export default {
  name: 'PostForm',
  props: {
    entity: {
      type: String,
      required: true,
    },
    entityId: {
      type: Number,
      required: true,
    },
    accessLevel: {
      type: String,
      required: true,
    },
    oldContent: {
      type: String,
      required: false,
    },
    oldTitle: {
      type: String,
      required: false,
    },
    isNew: {
      type: Boolean,
      required: false,
    },
    id: {
      type: Number,
      required: false,
    },
    contentType: {
      type: String,
      required: false,
    },
  },

  components: {
    UserAvatar,
    QuillEditor,
  },

  mixins: [disableButton],
  data() {
    return {
      isFormVisible: false,
      title: "",
      content: null,
      text: "",
      inputHeight: null,
      editorOptions: {
        //debug: 'info',
        // modules: {
        //   toolbar: true
        // },
        placeholder: 'Write post...',        
        //theme: 'bubble'
      }
    };
  },
  methods: {
    showMessage,
    async requestAddPost() {
      this.disableButton('save-post');
      const { entity, entityId, accessLevel, text, title } = this;
      let {contentType} = this;
      if( contentType == undefined || contentType == null || contentType == '' ) {  
        contentType = 'text';
      }
      const { success } = await addBlogPost(entity, entityId, title, text, contentType, accessLevel, false);
      this.enableButton('save-post');

      if (success) {
        this.$emit('update-data');
        this.clearInput();
        this.showMessage({
          type: 'success',
          message: 'The post has been added',
        });
      }
    },

    async requestUpdatePost() {
      this.disableButton('save-post');
      const { id, accessLevel, text, title } = this;
      const { success } = await updateBlogPost(id, title, text, accessLevel, false);
      this.enableButton('save-post');

      if (success) {
        this.$emit('update-data');
        this.$emit('close-form');
        this.clearInput();
      }
    },

    toggleForm() {
      this.isFormVisible = !this.isFormVisible;
    },
    openForm() {
      if (!this.isFormVisible) {
        this.isFormVisible = true;

        const input = this.$refs.input;
        if (input) {
          this.$nextTick(() => input.focus());
        }
      }
    },
    validate() {
      const { isNew } = this;

      if( this.contentType === 'delta' ) {
        this.text = JSON.stringify(this.content.ops, null, 2);
      }
      else if( this.contentType === 'html' ) {
        this.text = this.content;
      }
      else if( this.contentType === 'markdown' ) {
        this.text = this.content;
      }      
      console.log('text:', this.text);

      if (this.text && this.text.trim()) {
        if (isNew) {
            this.requestAddPost();
        } else {
          this.requestUpdatePost();
        }
      } else {
        this.showMessage({
          type: 'error',
          message: 'Please enter post text',
        });
      }
    },
    autoSizeTextarea() {
      const input = this.$refs.input;
      const { text } = this;

      // TODO check if lesser lines
      if (input) {
        this.$nextTick(() => {
          if (text && text.trim()) {
            const { inputHeight } = this;
            const newInputHeight = input.scrollHeight;
            const newInputHeightWithOffset = newInputHeight + 30;

            if (inputHeight && inputHeight < newInputHeight) {
              //input.style.cssText = 'height:' + newInputHeightWithOffset + 'px';
            }

            this.inputHeight =
              inputHeight && inputHeight < newInputHeight
                ? newInputHeightWithOffset
                : newInputHeight;
          } else {
            //input.style.cssText = 'height: 36px';
          }
        });
      }
    },
    clearInput() {
      const { isNew, oldContent, oldTitle } = this;
      //const input = this.$refs.input ? this.$refs.input : null;
      const quillInput = this.$refs.quillInput ? this.$refs.quillInput : null;

      if (!isNew && oldContent) {
        this.text = oldContent;
        this.title = oldTitle;
        this.updateContent();
        this.autoSizeTextarea();
      } else {
        this.content = null;
        this.text = null;
        this.title = null;
        
        quillInput?.setContents('');
        
        // if (input) {
        //   //input.style.cssText = 'height: 36px';
        // }
      }
    },
    onReset() {
      const { isNew } = this;

      this.clearInput();
      if (!isNew) {
        //console.log('close form');
        this.$emit('close-form');
      }
    },
    keyPressed(event) {
      const { key, shiftKey } = event;
      const { isNew, isFormVisible } = this;

      if (key === 'Escape') {
        this.isFormVisible = false;

        if (isNew) {
          this.$emit('close-form');
        }
      }
    },
    updateContent() {
      if( this.contentType === 'delta' ) {
        this.content = JSON.parse(oldContent);
      }
      else {
        this.content = this.oldContent;
      }
    },
  },
  created() {
    this.autoSizeTextarea();

    const { oldContent, oldTitle } = this;
    if (oldContent) {
      this.text = oldContent;
      this.title = oldTitle;
      this.updateContent();
      this.isFormVisible = true;
    }
  },
  watch: {
    oldContent(newVal) {
      console.log('newVal:', newVal);
      this.text = newVal;
      this.updateContent();
      if (newVal) {
        this.isFormVisible = true;
      }
    },
    oldTitle(newVal) {
      this.title = newVal;
    },
  },
  computed: {
    currentUser() {
        return this.$store.state.user;
      },
  },
};
</script>

<style lang="scss">
.post-form {
  $this: &;

  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  overflow: hidden;
  cursor: text;

  padding: var(--global-dimension-size-200) var(--global-dimension-size-300);
  border-radius: var(--border-radius-base);

  font-size: var(--font-size-200);
  background-color: var(--color-gray-50);

  &--expand {
    cursor: unset;
    flex-wrap: wrap;
    align-items: flex-start;

    #{$this}__label {
      display: none;
    }
    #{$this}__input {
      display: block;
      margin-top: var(--global-dimension-size-125);
      cursor: unset;
      flex-wrap: wrap;
      align-items: flex-start;
      &__text {
        width: 100%;
        height: 100px;
      }
      &__quill {
        width: 100%;
        height: 400px;
      }
    }
    #{$this}__bottom {
      display: flex;
    }
  }

  &--editing {
    padding: 0;
  }

  &__avatar {
    margin-right: var(--global-dimension-size-125);
  }

  &__label {
  }

  &__input {
    display: none;
    flex-grow: 1;
    max-width: calc(100% - 46px);
    min-height: 36px;
    height: auto;
    padding: 0;

    resize: none;
    border: none;
    box-shadow: none;
    border-radius: unset;
    box-sizing: content-box;
    overflow: hidden;

    line-height: 1.6;

    &:focus {
      border: none;
      outline: none;
    }
  }

  &__bottom {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    display: none;
    margin-top: var(--global-dimension-size-125);
  }

  &__extra {
  }
}
</style>
